import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SiteHeader } from "@/components/site-header";
import { SiteFooter } from "@/components/site-footer";
import { getSiteBrand } from "@/lib/site-brand.functions";
import { SiteBrandProvider } from "@/lib/site-brand-context";

export const Route = createFileRoute("/_site")({
  loader: () => getSiteBrand(),
  component: SiteLayout,
});

function SiteLayout() {
  const brand = Route.useLoaderData();
  if (brand === "keys4steam") {
    return (
      <SiteBrandProvider brand={brand}>
        <div className="keys4steam min-h-screen bg-background text-foreground">
          <Outlet />
        </div>
      </SiteBrandProvider>
    );
  }
  return (
    <SiteBrandProvider brand={brand}>
      <div className="flex min-h-screen flex-col">
        <SiteHeader />
        <main className="flex-1"><Outlet /></main>
        <SiteFooter />
      </div>
    </SiteBrandProvider>
  );
}
